import { Theme, css } from '@emotion/react';

export const buttonStyle = ({ spacing }: Theme) => [
  css`
    margin: ${spacing(-0.25)}px 0 ${spacing(-0.25)}px ${spacing(0.5)}px;
  `,
];
